import KlarnaComponentValidation from "../../../../content/sdk/react-native/2.x.x/primerHeadlessUniversalCheckout/_klarna/klarnaComponentValidation.mdx";
import * as React from 'react';
export default {
  KlarnaComponentValidation,
  React
};